import type { ReactElement, SVGProps } from 'react';
import { useId } from 'react';

import type { IconSVGProps } from './types';

/**
 * ResidenceIcon: ícono para “residencia / domicilio”.
 */
export const ResidenceIcon = ({
  className,
  width = 16,
  height = 17,
  ...props
}: IconSVGProps): ReactElement<SVGProps<SVGSVGElement>> => {
  const clipId = useId();

  return (
    <svg
      viewBox="0 0 16 17"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      aria-hidden
      focusable="false"
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M7 10.4044V15.3009L7.68813 16.3328C7.83656 16.5553 8.16375 16.5553 8.31219 16.3328L9 15.3009V10.4044C8.67531 10.4644 8.34188 10.5 8 10.5C7.65812 10.5 7.32469 10.4644 7 10.4044ZM8 0.5C5.51469 0.5 3.5 2.51469 3.5 5C3.5 7.48531 5.51469 9.5 8 9.5C10.4853 9.5 12.5 7.48531 12.5 5C12.5 2.51469 10.4853 0.5 8 0.5ZM8 2.875C6.82812 2.875 5.875 3.82812 5.875 5C5.875 5.20687 5.70688 5.375 5.5 5.375C5.29313 5.375 5.125 5.20687 5.125 5C5.125 3.41469 6.415 2.125 8 2.125C8.20687 2.125 8.375 2.29313 8.375 2.5C8.375 2.70688 8.20687 2.875 8 2.875Z"
          fill="inherit"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
